import React, { useEffect, useState } from 'react';
import ButtonBack from './images/x.png';
import AntFood from './images/AntFood.png';
import Info from './images/Icon_Info.png';
import { toast } from 'react-hot-toast';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function AntFoodPopup({ onClose, antShopMintInfo }) {
  const [value, setValue] = useState(0);
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const { buyTokenFromShop } = useSolanaWeb3();

  const handleInputChange = (event) => {
    const newValue = parseInt(event.target.value);
    if (!isNaN(newValue)) {
      setValue(newValue);
    }
  };

  const handleIncrement = () => {
    if (value < 999) {
      setValue((prevValue) => prevValue + 1);
    }
  };

  const handleDecrement = () => {
    if (value > 0) {
      setValue((prevValue) => prevValue - 1);
    }
  };

  useEffect(() => {
    if (antShopMintInfo) {
      setPrice(antShopMintInfo.price);  // Assuming price is in SOL
    }
  }, [antShopMintInfo]);

  const handleBuyNowButtonClicked = async () => {
    try {
      setLoading(true);
      const antFoodMintAddress = antShopMintInfo.mintAddress; // Ensure this is the correct mint address
      await buyTokenFromShop(process.env.REACT_APP_ANT_FOOD,value,10,4);
      toast.success("Transaction was successful");
    } catch (err) {
      console.log("ANTFood buy error:", err);
      toast.error("Something went wrong!");
      // Add more specific error handling as needed
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="popup-container">
    <div className="popup" id="shoppopup">
      <button className="button-close" onClick={onClose}>
        <img src={ButtonBack} alt="Close button" />
      </button>
      <div className="popup-content-left">
        <div className="popupimage-holder">
          <img src={AntFood} alt="AntFood" />
        </div>
      </div>
      <div className="popup-content-right">
        <div className="popupinfo-holder">
        <h2>ANT Food</h2>
            <p>By providing food for the Kingdom, you earn a premium ANT</p>
            <h3>40 Cent</h3>
          <div className="amount-box">
            <button onClick={handleDecrement}>-</button>
            <input
              type="number"
              value={value}
              onChange={handleInputChange}
            />
            <button onClick={handleIncrement}>+</button>
          </div>
          <div className="counter">
            <h3>Total:</h3>
            <h3>{(value * price / 100).toFixed(3)} $</h3> 
          </div>
          <button className="buy-button" onClick={handleBuyNowButtonClicked} disabled={loading}>
            <span>{loading ? "Loading..." : "BUY NOW"}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
);
}

export default AntFoodPopup;